import React from 'react';
import numeral from 'numeral';
import {getPercentagePopUp} from '../utils/utils';

const Popup = ({geo_type, geo_name, population_type, population_value, category, percentage, table}) => (
    `<div class="popUp">
        <strong>${geo_name}</strong>
        <p>${table}: ${category}</p>
        <p>${population_type}: ${numeral(population_value).format('0,0')}</p>
        <p>${getPercentagePopUp(geo_type, percentage)}</p>
    </div>`
  );
  
  export default Popup;



// WEBPACK FOOTER //
// ./src/components/Popup.js